import { Suspense, lazy, memo } from "react";

import { AsyncDataSuspense } from "@tsp-core/async/components/async-data-suspense";

import { accountsApi } from "@tsp-domains/accounts/api";
import { contractTypesApi } from "@tsp-domains/contract-types/api";
import { contractorsAccountsApi } from "@tsp-domains/contractor-accounts/api";
import { contractsApi } from "@tsp-domains/contracts/api";
import { overviewApi } from "@tsp-domains/overview/api";
import { systemTypesApi } from "@tsp-domains/system-types/api";

import { Access } from "../../features/auth/components";
import { Layout } from "../../features/layout";
import { UserStateData } from "../../features/user";

const Content = lazy(() => import("./main-page.content"));

const checkAccess = (user: UserStateData) => user.authenticated;

function MainRoute() {
  const loadContractTypesDictionary = contractTypesApi.useGetContractTypesDictionaryQuery();
  const loadOverviewDataQuery = overviewApi.useLoadOverviewDataQuery();
  const loadUserAccountsQuery = accountsApi.useGetUserAccountsInfoQuery();
  const loadContractorsAccountsQuery = contractorsAccountsApi.useGetContractorsAccountsQuery();
  const loadUserContractsQuery = contractsApi.useLoadUserContractsQuery();
  const loadSystemTypesDictionaryQuery = systemTypesApi.useGetSystemTypesDictionaryQuery();

  return (
    <Access checkAccess={checkAccess}>
      <Layout loading={false}>
        <AsyncDataSuspense
          queries={[
            loadContractTypesDictionary,
            loadOverviewDataQuery,
            loadUserAccountsQuery,
            loadUserContractsQuery,
            loadContractorsAccountsQuery,
            loadSystemTypesDictionaryQuery,
          ]}
        >
          <Suspense fallback={null}>
            <Content />
          </Suspense>
        </AsyncDataSuspense>
      </Layout>
    </Access>
  );
}

export default memo(MainRoute);
